export default "__VITE_ASSET__B8aV84sq__"